module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-6-svgrepo-com.3ce5c20b.svg";